import React, { useContext, useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { TabPanel, TabView } from "primereact/tabview";
import { Image } from "primereact/image";
import { ConfirmDialog } from "primereact/confirmdialog";
import PoliticalPartyService from "../../services/PoliticalPartyService";
import { formatDate } from "../../config/Config";
import PoliticalPartyDetail from "./PoliticalPartyDetail";
import AddPartyDocument from "../../componets/AddPartyDocument";
import AddPoliticalParty from "../../componets/AddPoliticalParty";
import { AppDB } from "../../App";
import { PoliticalPartyDBContext } from "./PoliticalPartyDBContext";
import { reportService } from "../../services/ReportService";
import ScreenLoader from "../../componets/ScreenLoader";
import MultiFilterSearch from "../../componets/MultiFilterSearch";

export const PoliticalPartyManagement = () => {
	var { permission, toast } = useContext(AppDB);
	var { refresh_politicalParties, selectedParty, setSelectedParty, isOnlyView, setIsOnlyView, contestationPeriodID, setContestationPeriodID } =
		useContext(PoliticalPartyDBContext);

	var [politicalParties, setPoliticalParties] = useState([]);
	var [politicalPartiesFilter, setPoliticalPartiesFilter] = useState([]);
	var [politicalPartiesFilterValue, setPoliticalPartiesFilterValue] = useState("");
	var [showPoliticalDialog, setShowPoliticalDialog] = useState(false);

	var [loading, setLoading] = useState(true);
	var [refresh, setRefresh] = useState(true);

	var political = new PoliticalPartyService();
	useEffect(() => {
		console.log(political);

		setLoading(true);
		political.getAllPoliticalParties().then((res) => {
			setPoliticalParties(res.politicalParties);
			console.log(res);
			setLoading(false);
		});
	}, [refresh, refresh_politicalParties]);

	const [selectedEvent, setselectedEvent] = useState(null);
	const [showReport, setshowReport] = useState(false);
	const handleDownloadReport = () => {
		var payload = {
			// ReportID: 13,
			// eventid: selectedEvent.eventID,
			// DelimitationLevelID: selectedEvent?.eventDelimitationLevelId,
			// DelimitationID: selectedEvent?.eventDelimitationId,
			// IncludeSubdelimitations: true
		};
		getReport(payload);
	};
	const [base64, setBase64] = useState(null);
	const [fetchReportLoader, setfetchReportLoader] = useState(false);
	const [showReportDialog, setReportShowDialog] = useState(false);
	const getReport = (data) => {
		setfetchReportLoader(true);
		reportService
			.getReport(data)
			.then((response) => {
				setfetchReportLoader(false);

				if (response?.success) {
					setshowReport(true);
					setBase64(response.data);
					toast.show({ severity: "success", summary: "", detail: response.message, life: 3000 });
				} else {
					toast.show({ severity: "error", summary: "Message", detail: "No data found", life: 3000 });
				}
			})
			.catch((err) => {
				console.log(err);
				setfetchReportLoader(false);
				return toast.show({ severity: "error", summary: "Message", detail: "Something went wrong.", life: 3000 });
			});
	};

	const header = (
		<div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
			<h5> Political Parties</h5>
		</div>
	);
	return (
		<>
			<ScreenLoader visible={fetchReportLoader} />
			<div className="card  p-align-stretch vertical-container">
				<h5>Political Parties</h5>
				<div className="">
					<Toolbar
						className="mb-4"
						left={
							<div>
								<Button
									className="p-button-success mr-2"
									icon="pi pi-plus"
									label="Add Party"
									onClick={(e) => {
										setShowPoliticalDialog(true);
									}}
								/>
							</div>
						}
						right={
							<div>
								<span className="block mt-2 md:mt-0 p-input-icon-left">
									<i className="pi pi-search" />
									<InputText
										value={politicalPartiesFilterValue}
										onChange={(e) => {
											var val = e.target.value;
											setPoliticalPartiesFilterValue(val);
											var res = politicalParties.filter((e) => !e.abbreviation?.includes(val) || !e.name?.includes(val));
											setPoliticalPartiesFilter(res);
										}}
										placeholder="Search a Political Party"
									/>
								</span>
							</div>
						}
					></Toolbar>
				</div>
				<div className="grid my-2 hidden">
					<Button
						disabled={""}
						label="Print"
						loading={loading}
						onClick={() => {
							handleDownloadReport();
						}}
						className="p-button-primary mr-3 ml-2"
					/>
				</div>
				<AddPartyDocument
				//   PoliticalPartyID={SelectedPoliticalParty?.PoliticalPartyID} show={showAddDocumentForm} setShow={setShowAddDocumentForm} onSubmit={documentsHandler}
				/>

				{/* <AddP
            artyExecutiveMember PoliticalPartyID={SelectedPoliticalParty?.PoliticalPartyID} show={showAddExecutiveForm} setShow={setShowAddExecutiveForm} onSubmit={execMembersHandler} /> */}

				{showPoliticalDialog && (
					<>
						<AddPoliticalParty
							show={showPoliticalDialog}
							setShow={setShowPoliticalDialog}
							canRefresh={() => {
								setRefresh(!refresh);
							}}
						/>
					</>
				)}

				{selectedParty !== null && (
					<>
						<PoliticalPartyDetail />
					</>
				)}
				


				<DataTable
					size="small"
					scrollable={true}
					value={politicalPartiesFilter.length > 0 ? politicalPartiesFilter : politicalParties}
					dataKey="id"
					paginator
					rows={10}
					rowsPerPageOptions={[5, 10, 25]}
					className="datatable-responsive"
					currentPageReportTemplate="Showing {first} to {last} of {totalRecords} political parties"
					emptyMessage="No political party found."
					//header={header}
					responsiveLayout="scroll"
					// selection={SelectedPoliticalParty}
					// onSelectionChange={(e) => setSelectedPoliticalParty(e.value)}
					resizableColumns
					columnResizeMode="expand"
					// filters={filters}
					filterDisplay="Name"
					globalFilterFields={["Name"]}
					loading={loading}
				>
					<Column field="name" header="Name" sortable></Column>
					<Column field="abbreviation" header="Abbreviation" sortable></Column>
					{/* <Column field="description" header="Description"></Column> */}
					{/* <Column field="slogan" header="Slogan"></Column> */}
					{/* <Column
							field="logo"
							header="Logo"
							body={(e) => (
								<Image
									preview={true}
									src={e.logo}
									template="Logo"
									alt="Logo"
									width="100px"
									style={{ width: "100px", objectFit: "cover" }}
								/>
							)}
							headerStyle={{ width: "14%", minWidth: "10rem" }}
						></Column> */}
					<Column field="DateRegistered" header="Date Registered" body={(e) => formatDate(e?.registeredDate)}></Column>
					{/* <Column field="Annivesary" header="Anniversary" body={(e) => formatDate(e?.annivesary)}></Column> */}
					<Column
						field="Status"
						header="Status"
						body={(e) =>
							parseInt(e.politicalPartyStatusID) === 1 ? (
								<Button
									label="Active"
									style={{ textAlign: "center", height: "30px" }}
									className="p-button-success p-button-rounded"
								/>
							) : (
								<Button
									label="Not Active"
									style={{ textAlign: "center", height: "30px" }}
									className="p-button-danger p-button-rounded"
								/>
							)
						}
					></Column>
					<Column
						field="actions"
						header="Actions"
						body={(e) => (
							<>
								<Button
									style={{ textAlign: "center", width: "30px", height: "30px" }}
									icon={"pi pi-pencil"}
									className="p-button-primary p-button-rounded mr-2 "
									tooltip="Click to Edit"
									onClick={(a) => {
										setIsOnlyView(false);
										setSelectedParty(e);
									}}
								/>
								{/* <Button
									style={{
										textAlign: "center",
										width: "30px",
										height: "30px"
									}}
									icon={"pi pi-eye"}
									tooltipOptions={{ position: "top" }}
									className="p-button-primary p-button-rounded mr-2"
									tooltip="Click to View"
									onClick={(a) => {
										setIsOnlyView(true);
										setSelectedParty(e);
									}}
								/> */}
								{parseInt(e.Status) == 1 ? (
									<Button
										onClick={(a) => {
											// deActivateHandler(e.PoliticalPartyID);
										}}
										style={{ textAlign: "center", width: "30px", height: "30px" }}
										icon={"pi pi-times"}
										className="p-button-danger p-button-rounded mr-2"
										tooltip="Click to De-Activate"
									/>
								) : (
									<Button
										disabled
										style={{ textAlign: "center", width: "30px", height: "30px" }}
										icon={"pi pi- pi-times"}
										className="p-button-danger p-button-rounded mr-2"
										tooltip="Click to Activate"
									/>
								)}
							</>
						)}
					></Column>
				</DataTable>
			</div>
		</>
	);
};
